// The editor's language resources; importing this module makes `i18next.t` usable.
import { initI18n } from "@pergamenos/shared/i18n/i18n.ts";

import en from "./locales/en/editor.json";

/** The editor's language as last chosen (empty = the browser's). */
export const LANGUAGE_KEY = "pg.editor.language";

export function storedLanguage(): string {
  try {
    return localStorage.getItem(LANGUAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

const lazy = (load: () => Promise<{ default: unknown }>) => () => load().then((m) => ({ editor: m.default as typeof en }));

export const i18n = initI18n(
  {
    en: { editor: en },
    de: lazy(() => import("./locales/de/editor.json")),
    ja: lazy(() => import("./locales/ja/editor.json")),
    ar: lazy(() => import("./locales/ar/editor.json")),
  },
  "editor",
  storedLanguage(),
);
